/**
 * @generated SignedSource<<d83e695be6319708d2c7acdd040809d1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GroupTableBody_project$data = {
  readonly key: string;
  readonly " $fragmentSpreads": FragmentRefs<"Rows_project">;
  readonly " $fragmentType": "GroupTableBody_project";
};
export type GroupTableBody_project$key = {
  readonly " $data"?: GroupTableBody_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"GroupTableBody_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "GroupTableBody_project",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Rows_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "b1bf39d9e47d705fe4c5f720da27e3ef";

export default node;
